import { render, staticRenderFns } from "./Rule.vue?vue&type=template&id=09210619&scoped=true&lang=pug&"
import script from "./Rule.vue?vue&type=script&lang=js&"
export * from "./Rule.vue?vue&type=script&lang=js&"
import style0 from "./Rule.vue?vue&type=style&index=0&id=09210619&scoped=true&lang=scss&"
import style1 from "./Rule.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09210619",
  null
  
)

export default component.exports